<div class="absolute overflow-hidden inset-0 flex items-end opacity-0 transition-opacity" [class]="showSheet() ? 'opacity-100 pointer-events-auto' : ''">
    <!-- OVERLAY -->
    <div class="absolute inset-0 bg-black/40 cursor-pointer" (click)="close(); $event.stopPropagation()" (keydown.escape)="close()" tabindex="0">

        <!-- BOTTOM SHEET CONTAINER -->
        <div
          #bottomSheet
          class="bottomSheet relative w-full bg-black/80 backdrop-blur-sm text-white rounded-l-2xl rounded-r-2xl flex flex-col"
          [style.min-height]="isShortViewport ? '100vh' : '95vh'"
          (touchstart)="onDragStart($event)" 
          (mousedown)="onDragStart($event)" 
          (click)="$event.stopPropagation()" 
          (keydown)="$event.stopPropagation()"
          tabindex="0">
            
            <!-- HANDLE -->
            <div class="px-3 py-2 cursor-grab touch-none flex justify-center items-center active:cursor-grabbing">
                <div class="w-20 h-1 bg-white/30 rounded-xs"></div>
            </div>
             
            <!-- CONTENT -->
            <div class="overflow-y-auto pt-0 pb-4 px-4 grow">
                <ng-template #sheetContent/>
            </div>

        </div>

    </div>

</div>
